import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../App.css';

import EndOfProject from './EndOfProject';

import code_icon from '../Images/code-icon.svg';
import arrow_icon from '../Images/arrow-icon.svg';
import puzzle_icon from '../Images/puzzle-icon.svg';
import shopping_icon from '../Images/shopping-icon.svg';
import database_icon from '../Images/database-icon.svg';
import user_icon from '../Images/user-icon.svg';

import projectbizgainz from '../Images/bizgainz-project.jpg';
import bisonmfg from '../Images/bizgainz-bisonmfg.jpg';
import duckdive from '../Images/bizgainz-duckdive.jpg';
import elbocado from '../Images/bizgainz-elbocado.jpg';
import kabulschicken from '../Images/bizgainz-kabulschicken.jpg';
import mrgmarinesolutions from '../Images/bizgainz-mrgmarinesolutions.jpg';
import surfnslaw from '../Images/bizgainz-surfnslaw.jpg';
import wegotbeefjerky from '../Images/bizgainz-wegotbeefjerky.jpg';


class ProjectBizGainz extends Component {
  
    constructor(props) {
        super();
        this.props = props;
    }
  
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount(){

  }

  visitWebsite() {
    window.location.href = "https://bizgainz.com";
  }

  render () {
    
    const footerYear = new Date().getUTCFullYear();

    return (
        
      <div id="project">

        <div className="project-content-top">
          
            <p className="project-title-large">BizGainz E-Commerce Platform: E-Commerce Web Services</p>
            <img className="project-image-rounded-2" src={projectbizgainz} alt=""></img>

            <div className="project-text-container">
              <p className="project-text-medium">Summary</p>
            </div>
            <div className="project-overview">
              <div className="project-overview-left">
                <div className="project-text-container-2">
                  <p className="project-text-small">Mission</p>
                  <p className="project-paragraph">As president and founder of BizGainz, I built an e-commerce platform to give local small businesses an online storefront. What started in the San Diego farmers market community has expanded nationwide with solutions for e-commerce, appointment booking, and catering ordering.</p>
                </div>
                <div className="project-text-container-2">
                  <p className="project-text-small">My Contributions</p>
                  <p className="project-paragraph">I designed and developed the BizGainz e-commerce platform which features a clean UI, hassle-free store setup, and tools to help businesses grow. My services include: Website Development, Hosting + Maintenance, E-Commerce Solutions, Booking Solutions, Payment Integration, Email Notifications, Email Marketing, Continuous Website Support, and a number of client perks.</p>
                </div>
              </div>
              <div className="project-overview-right">
                <div className="project-text-container-3">
                  <p className="project-text-small">Link</p>
                  <div className="button" onClick={(e) => {this.visitWebsite()}}>
                    <p>bizgainz.com</p>
                    <img className="button-icon" src={arrow_icon} alt=""></img>
                  </div>
                </div>

                <div className="project-text-container-3">
                  <p className="project-text-small">My Tasks</p>

                  <div className="icon-bullet">
                    <img className="bullet-icon" src={code_icon} alt=""></img>
                    <p className="project-paragraph">Angular Programming</p>
                  </div>
                  <div className="icon-bullet">
                    <img className="bullet-icon" src={shopping_icon} alt=""></img>
                    <p className="project-paragraph">E-Commerce UX Design</p>
                  </div>
                  <div className="icon-bullet">
                    <img className="bullet-icon" src={user_icon} alt=""></img>
                    <p className="project-paragraph">Client Onboarding</p>
                  </div>
                  <div className="icon-bullet">
                    <img className="bullet-icon" src={database_icon} alt=""></img>
                    <p className="project-paragraph">Dynamo Database Dev</p>
                  </div>
                  <div className="icon-bullet">
                    <img className="bullet-icon" src={puzzle_icon} alt=""></img>
                    <p className="project-paragraph">AWS Full-Stack Engineering</p>
                  </div>
                </div>

              </div>
            </div>
        </div>

        <div className="project-content">
          
          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">For Local Vendors</p>
              <p className="project-paragraph">Local vendors like WeGotBeefJerky make it easy for customers to order their beef jerky products with options for bundling and XL sizes to maximize their sales.</p>
            </div>
            <img className="project-image-nobordered" src={wegotbeefjerky} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">For Handmade Products</p>
              <p className="project-paragraph">Craftsman like Bisonmfg offers a seamless shopping experience of their cutting board products with upsell features to increase the cart total at checkout.</p>
            </div>
            <img className="project-image-nobordered" src={bisonmfg} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">For Restaurant Ordering</p>
              <p className="project-paragraph">Local restaurant Surf'N Slaw allows for easy ordering and pickup with features for customizing the entrees with priced add-ons.</p>
            </div>
            <img className="project-image-nobordered" src={surfnslaw} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">For Catering Businesses</p>
              <p className="project-paragraph">Mediteranean restaurant Kabul's Chicken makes it easy for customers to order entrees, sides, and drinks while easily selecting the number of orders and setting  event details.</p>
            </div>
            <img className="project-image-nobordered" src={kabulschicken} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">For Smaller Catering Menus</p>
              <p className="project-paragraph">Catering businesses like El Bocado make it easy for customers to order food and select the number of orders with customized forms for setting the event details.</p>
            </div>
            <img className="project-image-bordered" src={elbocado} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">For Repair Businesses</p>
              <p className="project-paragraph">Boat repair service MRG Marine Solutions provides an intuitive 'Get a Quote' feature with a customized intake form.</p>
            </div>
            <img className="project-image-nobordered" src={mrgmarinesolutions} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">For Reservations</p>
              <p className="project-paragraph">Karaoke bar Duck Dive allows customers to reserve events for the night like karaoke and private parties with date and time selection options.</p>
            </div>
            <img className="project-image-nobordered" src={duckdive} alt=""></img>
          </div>

          <EndOfProject/>
  
        </div>
                
      </div>
    );
  }
}

export default ProjectBizGainz;
